import { Button } from '../Buttons/Button'
import { Check } from 'almanac-ui/icons'
import Styles from './SingleMenuDropdown.module.scss'
import cx from 'classnames'
import { ReactElement } from 'react'
import { ConditionalWrapper } from 'common/ConditionalWrapper/ConditionalWrapper'
import { ShortcutAwareTooltip, ShortcutAwareTooltipProps } from 'common/Prose/utils/ShortcutAwareTooltip'

interface Props {
  active?: boolean
  handleClick?: () => void
  icon?: ReactElement
  label?: string
  ariaLabel?: string
  disabled?: boolean
  rightContent?: React.ReactNode
  tooltip?: ShortcutAwareTooltipProps
}

export const SingleMenuDropdownItem = ({
  active,
  handleClick,
  icon,
  label,
  ariaLabel,
  disabled,
  rightContent,
  tooltip,
}: Props) => {
  return (
    <ConditionalWrapper
      condition={tooltip && tooltip.label !== undefined}
      wrapper={(e) => (
        <ShortcutAwareTooltip {...tooltip} label={tooltip?.label || ''}>
          {e}
        </ShortcutAwareTooltip>
      )}
    >
      <Button
        className={cx(Styles.item, {
          [Styles.selected]: active,
        })}
        aria-label={ariaLabel || label}
        active={active}
        onClick={handleClick}
        unStyled={!!label}
        disabled={disabled}
      >
        {icon}
        {label && (
          <>
            <span className={Styles.title}>{label}</span>
            {active && (
              <div className={Styles.check}>
                <Check />
              </div>
            )}
          </>
        )}
        {rightContent && <div className={Styles.rightContent}>{rightContent}</div>}
      </Button>
    </ConditionalWrapper>
  )
}
